
const Columns4 = () => [
  {
    dataField: "page",
    text: "Página",
    sort: true,
    style: { width: "5%" },
  },

 
  {
    dataField: "pageTypeName",
    text: "Tipo Documento",
    sort: true,

    style: { width: "5%" },
   
  },
];

export default Columns4;
